import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'enableLoyaltyWallet',
  initialState: false,
  reducers: {
    setEnableLoyaltyWallet(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setEnableLoyaltyWallet } = slice.actions;

export default slice.reducer;
